import { useQuery } from '@tanstack/react-query';
import {
  Transcription,
  TranscriptionListResponse,
  V2CallsTranscriptionsService,
} from 'src/api/generated';
import { ApiResponse } from 'src/hooks/api/api';

interface CallTranscriptionResponse extends ApiResponse {
  transcription: Transcription | null;
}

export const useCallTranscription = (
  callId: number,
  enabled: boolean = true
): CallTranscriptionResponse => {
  const fetchTranscriptionByCallId =
    async (): Promise<Transcription | null> => {
      const filterBy = `recording.callId=${callId}`;
      const response: TranscriptionListResponse =
        await V2CallsTranscriptionsService.getTranscriptions(
          filterBy,
          undefined,
          undefined,
          undefined,
          1
        );
      return response.items[0] ?? null;
    };

  const {
    data,
    error,
    isLoading: loading,
    refetch,
  } = useQuery({
    queryKey: ['calls/transcription-by-call', callId],
    queryFn: fetchTranscriptionByCallId,
    enabled,
  });

  return {
    loading,
    error,
    transcription: data ?? null,
    refetch,
  };
};
